export default Object.assign(
  theme => {
    return {
      container: {
       
      }
    }
  }
)


// WEBPACK FOOTER //
// ./src/app/configuration/Template/theme/components/adminView/AdminConfigManager/AdminDataMigrationFilter.js